<div class="toolbox-edit-dialog-container">
  <p class="title">Edit Toolbox Item</p>
  <form [formGroup]="editItemForm" class="toolbox-form" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>Text</mat-label>
      <textarea
        formControlName="text"
        matInput
        matTextareaAutosize
        matAutosizeMinRows="4"
        matAutosizeMaxRows="10"
        placeholder=""
        value="{{data.itemText}}"
        ></textarea>
    </mat-form-field>
    <div class="buttons">
      <button mat-flat-button color="secondary" (click)="close(false)">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!editItemForm.valid">Update</button>
    </div>
  </form>
  <arb-message class="message" [message$]="error$"></arb-message>
</div>